import React from 'react'
import { Layout } from '../components/Layout/Layout'
import { FacilityCountsCards } from '../components/FacilityCounts/FacilityCounts'
import { FacilityDetailsCard } from '../components/FacilityDetailsCard/FacilityDetailsCard'
import { NumberEducationCard } from '../components/NumberEducationCard/NumberEducationCard'
import { FacilityGrid } from '../components/FacilityGrid/FacilityGrid'
import { Grid } from 'semantic-ui-react'
import { SubMenu } from '../components/SubMenu/SubMenu'
import { parseQueryString } from '../utils/queryString'
import { useLocation } from 'react-router'
import { Responsive } from '../components/Responsive/Responsive'
import InitialPropsContext from '../components/InitialPropsContext/InitialPropsContext'

const FacilitiesDetailsContainer = () => {
  const { accountId, accountName } = React.useContext(InitialPropsContext)
  // Next's router.asPath carried the query string; useLocation().search is the
  // same text. The facility is identified by query params, not a path segment,
  // and that stays true so existing links keep resolving.
  const { search } = useLocation()

  const { facilityId, facilityName } = parseQueryString<{
    facilityId: number
    facilityName: string
  }>(search)

  if (!accountId || !accountName) {
    return null
  }

  if (!facilityId || !facilityName) {
    return null
  }

  return (
    <Layout title={accountName}>
      <SubMenu
        title={facilityName}
        accountId={accountId}
        accountName={accountName}
      />
      <Grid
        verticalAlign="top"
        className="buildingBlock"
        style={{ margin: '0 -1em' }}
      >
        <Grid.Column mobile={16} computer={4}>
          <FacilityDetailsCard facilityId={facilityId} />
          <Responsive platform="desktop">
            <NumberEducationCard />
          </Responsive>
        </Grid.Column>
        <Grid.Column mobile={16} computer={12}>
          <FacilityCountsCards facilityId={facilityId} />
          <Responsive platform="mobile">
            <NumberEducationCard />
          </Responsive>
          <FacilityGrid
            accountId={accountId}
            facilityId={facilityId}
            facilityName={facilityName}
          />
        </Grid.Column>
      </Grid>
    </Layout>
  )
}

export default FacilitiesDetailsContainer
